import React from 'react';
import { ILongSteelOrdersState } from '../../../store/ducks/long-steel-orders/types';
import { ICustomer } from '../../../store/ducks/customers/types';
import SoldToView from './SoldToView';
import ShipToView from './ShipToView';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import { InvoicesState } from '../../../store/ducks/invoices/types';

interface IEmitterAndReceiverSelector {
  orderOrInvoiceState: ILongSteelOrdersState | InvoicesState;
  customerViewType: ECustomerTypeView;
  customers: ICustomer[];
  isUserAdmin: boolean;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
  receiverId: string;
  setReceiverId(receiverId: string): void;

  showCustomerStates: boolean;
  selectedStates: string[];
  onChangeStates(states: string[]): void;
}

const EmitterAndReceiverSelector: React.FC<IEmitterAndReceiverSelector> = ({
  orderOrInvoiceState,
  customerViewType,
  customers,
  isUserAdmin,
  selectedStates,
  onChangeStates,
  emitterIds,
  setEmitterIds,
  receiverId,
  setReceiverId,
  showCustomerStates
}) => {
  return (
    <>
      {(customerViewType === ECustomerTypeView.EMITTER || isUserAdmin) && (
        <SoldToView
          orderOrInvoiceState={orderOrInvoiceState}
          isUserAdmin={isUserAdmin}
          showCustomerStates={showCustomerStates}
          selectedStates={selectedStates}
          onChangeStates={onChangeStates}
          emitterIds={emitterIds}
          setEmitterIds={setEmitterIds}
          receiverId={receiverId}
          setReceiverId={setReceiverId}
          customers={customers}
        />
      )}

      {(customerViewType === ECustomerTypeView.RECEIVER ||
        customerViewType === ECustomerTypeView.FABRICATION_RECEIVER) && (
        <ShipToView
          orderOrInvoiceState={orderOrInvoiceState}
          isUserAdmin={isUserAdmin}
          emitterIds={emitterIds}
          setEmitterIds={setEmitterIds}
          receiverId={receiverId}
          setReceiverId={setReceiverId}
          customers={customers}
        />
      )}
    </>
  );
};

export default EmitterAndReceiverSelector;
